import { j as t } from "../../../../../node_modules/react/jsx-runtime.js";
import { memo as g, useMemo as v } from "react";
import { clsx as o } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import { Typography as x } from "../../../../atoms/Typography/Typography.js";
import N from "../TableSort/TableSort.js";
import s from "../../Table.module.scss.js";
const b = ({
  id: e,
  type: a,
  text: c,
  alignment: r,
  disabled: m,
  onSort: l,
  sortDir: n,
  custom: i,
  children: f,
  width: u,
  colSpan: d,
  pinnedFirst: h,
  pinnedLast: p,
  selectable: y
}) => {
  const j = document.body.getAttribute("dir") === "rtl", C = v(() => f || (i ? /* @__PURE__ */ t.jsx(
    "div",
    {
      className: o("flex justify-start items-center h-full", {
        "!justify-start": r === "left",
        "!justify-center": r === "center",
        "!justify-end": r === "right"
      }),
      children: i
    }
  ) : a === "header-group" ? /* @__PURE__ */ t.jsx("div", { className: "flex items-center justify-center w-full h-full min-h-500", children: /* @__PURE__ */ t.jsx(
    x,
    {
      text: c,
      variant: "interface/strong/s",
      textColor: "color/fg/default"
    }
  ) }) : /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: o("flex items-center justify-start gap-050 w-full h-full min-h-500", {
        "justify-start": r === "left",
        "justify-center": r === "center",
        "justify-end": r === "right",
        "!w-300": e === "select-col"
      }),
      children: [
        /* @__PURE__ */ t.jsx(
          x,
          {
            text: c,
            variant: "interface/medium/s",
            textColor: "color/fg/light"
          }
        ),
        l && /* @__PURE__ */ t.jsx("div", { className: s.sortContainer, children: /* @__PURE__ */ t.jsx(N, { direction: n }) })
      ]
    }
  )), [i, a, c, r, l, n, e, f]);
  return /* @__PURE__ */ t.jsxs(
    "th",
    {
      className: o(s.headerCell, {
        "opacity-40 pointer-events-none cursor-not-allowed": m,
        [s.tablePinnedFirstColumn]: h && !(e != null && e.toString().includes("select-col")),
        [s.tablePinnedLastColumn]: p && !(e != null && e.toString().includes("select-col")),
        [`sticky !z-[51] left-0 right-auto ${j ? "!right-0 !left-auto" : ""}`]: e == null ? void 0 : e.toString().includes("select-col"),
        "cursor-pointer": l
      }),
      "aria-disabled": m,
      colSpan: d ?? 1,
      "data-testid": `header-cell-${e}`,
      ...l && { onClick: () => l(n === "asc" ? "desc" : "asc") },
      style: {
        width: u,
        minWidth: u,
        maxWidth: u,
        ...y && h && (j ? { right: "40px" } : { left: "40px" })
      },
      children: [
        /* @__PURE__ */ t.jsx(
          "div",
          {
            className: o(s.thContentContainer, {
              [s.thGroupContainer]: a === "header-group"
            }),
            children: C
          }
        ),
        /* @__PURE__ */ t.jsx("div", { className: s.thBottomBorder })
      ]
    }
  );
}, R = g(b);
export {
  R as default
};
//# sourceMappingURL=HeaderCell.js.map
